import { postToApi } from '.'

export interface StakingPositionParams {
  wallet_address: string
  action: 'deposit' | 'withdraw' | 'redeem' | 'claim'
  amount: number
  tx_hash: string
  symbol: string
  stake_type: 'flexible' | 'fixed'
  vault_index: number
}

export async function logStakingPosition(params: StakingPositionParams): Promise<{
  success: boolean
}> {
  return await postToApi('/staking/positions', params)
}
